<template>
  <v-container>
    <v-navigation-drawer
      color="primary"
      v-model="drawer"
      app
      clipped
      left
      style="top: 64px; max-height: calc(100% - 64px)"
    >
      <v-list dense dark>
        <v-list-item-group v-model="model" mandatory v-if="dashboardListLoaded">
          <div v-for="dash in dashboards" :key="dash.uuid">
            <router-link
              class="white--text navigation-a-underline--remove"
              :to="{ name: 'dashboard', params: { id: dash.uuid } }"
            >
              <v-list-item link>
                <v-list-item-action>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{
                    lookupForTranslations(dash.name)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </router-link>
          </div>
        </v-list-item-group>
      </v-list>
      <v-list dense dark v-if="canUseKnowledgeBaseBtn">
        <v-list-item @click="handleHelp">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("components.navigationBar.dashboardsBar.help")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <powered-by-sentinel :is-navbar="true" />
      </template>
    </v-navigation-drawer>
    <help-dialog
      :dialog="helpDialog"
      @close="closeHelpDialog"
      v-if="helpDialog.active"
    ></help-dialog>
  </v-container>
</template>
<script>
import api from "@/utils/api.js";
import { mapGetters, mapState } from "vuex";
import HelpDialog from "@/components/dialogs/HelpDialog";
import constraints from "@/utils/constraints";
import PoweredBySentinel from "../banners/PoweredBySentinel.vue";

export default {
  name: "DashboardsBar",
  components: {
    HelpDialog,
    PoweredBySentinel,
  },
  data: () => ({
    drawer: true,
    dashboards: [],
    model: null,
    helpDialog: { location: null, active: false },
    dashboardListLoaded: false,
    canUseKnowledgeBaseBtn: false,
  }),
  created() {
    api.getDashboardList().then((resp) => {
      this.canUseKnowledgeBaseBtn =
        constraints.canUseKnowledgeBaseBtn("dashboards");
      this.dashboards = resp.data;
      this.dashboards.forEach((element, index) => {
        if (this.$route.path === "/dashboards/" + element.uuid) {
          this.model = index;
        }
      });
      if (this.dashboards.length !== 0) {
        this.dashboardListLoaded = true;
      }
    });
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "COLLAPSED") {
        this.drawer = mutation.payload;
      }
    });
  },

  watch: {
    drawer(val) {
      if (this.getDrawerStatus !== this.drawer) {
        this.$store.commit("COLLAPSED", val);
      }
    },
  },
  computed: {
    ...mapGetters(["getDrawerStatus"]),
  },
  methods: {
    lookupForTranslations(menu) {
      const translateMenusLookup = [
        {
          name: "Details",
          id: "details",
          path: "components.navigationBar.dashboardsBar.details",
        },
        {
          name: "Boats",
          id: "boats",
          path: "components.navigationBar.dashboardsBar.boats",
        },
        {
          name: "Insights",
          id: "insights",
          path: "components.navigationBar.dashboardsBar.insights",
        },
        {
          name: "Customer Service",
          id: "customerService",
          path: "components.navigationBar.dashboardsBar.customerService",
        },
        {
          name: "Sales",
          id: "sales",
          path: "components.navigationBar.dashboardsBar.sales",
        },
        {
          name: "Overview",
          id: "overview",
          path: "components.navigationBar.dashboardsBar.overview",
        },
        {
          name: "Fleet overview",
          id: "fleetOverview",
          path: "components.navigationBar.dashboardsBar.fleetOverview",
        },
      ];

      const translatedMenu = translateMenusLookup.find((item) => {
        return item.name === menu;
      });

      if (typeof translatedMenu === "undefined") {
        return menu;
      }

      return this.$t(translatedMenu.path);
    },
    closeHelpDialog(event) {
      if (event === "close") {
        this.helpDialog.active = false;
      }
    },
    handleHelp(event) {
      this.helpDialog.active = true;
      this.helpDialog.location = "dashboards";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
.navigation-text-size--hover {
  font-size: 14px;
  &:hover {
    color: --primary;
  }
}
.navigation-icon--hover {
  &:hover {
    color: --primary;
  }
}
.navigation-a-underline--remove {
  text-decoration: none;
}
</style>
